<template>
  <div class="tracking-link">
    <el-form inline size="small" class="padding-20">
      <el-form-item>
        <el-input placeholder="请输入链路ID" v-model="form.traceId"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="form.date"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :editable="false"
          unlink-panels
          :clearable="false"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
                <!-- :picker-options="pickerOptions" -->
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="padding-20">
    <el-table
      class="tracking-link-table"
      :data="tableData"
      style="margin-bottom: 20px;"
      row-key="id"
      v-loading="loading"
      border
      default-expand-all
      :tree-props="{children: 'spanTraceInfos', hasChildren: 'hasChildren'}"
    >
      <!-- eslint-disable-next-line max-len -->
      <el-table-column prop="serverName" show-overflow-tooltip label="服务名称" min-width="140px"></el-table-column>
      <el-table-column prop="invokeTime" label="调用时间"></el-table-column>
      <el-table-column prop="invokeType" label="调用方式"></el-table-column>
      <el-table-column prop="cost" label="响应时间(ms)" width="120"></el-table-column>
      <el-table-column prop="address" label="调用地址" width="200"></el-table-column>
      <el-table-column label="请求头" width="200px">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            class="tracking-link-row"
            type="primary"
            :underline="false"
            @click="handleFormat('请求头', scope.row.headers)"
          >{{ scope.row.headers }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="query" label="地址参数" width="140">
         <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            class="tracking-link-row"
            type="primary"
            :underline="false"
            @click="handleFormat('地址参数', scope.row.query)"
          >{{ scope.row.query }}</a>
        </template>
      </el-table-column>
      <el-table-column label="请求参数" width="200px">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            class="tracking-link-row"
            type="primary"
            :underline="false"
            @click="handleFormat('请求参数', scope.row.requestBody)"
          >{{ scope.row.requestBody }}</a>
        </template>
      </el-table-column>
      <el-table-column label="响应参数" width="200px">
        <template slot-scope="scope">
          <a
            href="javascript:void(0)"
            class="tracking-link-row"
            type="primary"
            :underline="false"
            @click="handleFormat('响应参数', scope.row.responseBody)"
          >{{ scope.row.responseBody }}</a>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="100px">
        <template slot-scope="{row}">
          <el-button
            v-if="row.curl"
            size="mini"
            type="primary"
            v-clipboard:copy="row.curl"
            v-clipboard:success="handleCopySuccess"
            v-clipboard:error="handleCopyError"
          >复制curl</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
      append-to-body
      modal-append-to-body
    >
      <div>
        <jsonView :data="formatData" v-if="canFormat" />
        <div v-else>{{ formatData }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-clipboard:copy="JSON.stringify(formatData, null, 2)"
          v-clipboard:success="handleCopySuccess"
          v-clipboard:error="handleCopyError"
          size="small">复制</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable no-underscore-dangle */
import jsonView from 'vue-json-views';
// eslint-disable-next-line import/no-unresolved
import JSONbig from 'json-bigint';
import moment from 'moment';
import { queryTraceInfo } from '@/api/tracking';

let uid = 1;
function formatTraceInfos(data) {
  data.forEach((item) => {
    // eslint-disable-next-line no-param-reassign
    item.id = uid++;
    if (item.spanTraceInfos && item.spanTraceInfos.length > 0) {
      formatTraceInfos(item.spanTraceInfos);
    }
  });
}

export default {
  props: {
    traceId: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      JSONbigString: JSONbig({ storeAsString: true }),
      tableData: [],
      loading: false,
      form: {
        traceId: '',
        date: [],
      },
      dialogVisible: false,
      title: '',
      formatData: {},
      canFormat: false,
      value1: [],
      startDate: '', // 时间
      minTime: 1652067884621, // 时间戳，对应时间为：'2021-04-20 12:00:00'
      maxTime: 1652154306, // 时间戳，对应时间为：'2021-04-25 12:00:00'
      pickerMinDate: null,
      pickerMaxDate: null,
      day: 1 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (date) => {
          if (this.pickerMinDate) {
            const time = date.getTime();
            return (
              time
                > (this.pickerMinDate + this.day)) || (time < (this.pickerMinDate - this.day));
          }
          return false;
        },
      },
    };
  },
  components: {
    jsonView,
  },
  methods: {
    handleCopySuccess() {
      this.dialogVisible = false;
      this.$message.success('复制成功');
    },
    handleCopyError() {
      this.$message.error('复制失败');
    },
    handleSearch() {
      this.queryTraceInfo();
    },
    formatRequestBody(data) {
      if (!data) {
        return [];
      }
      try {
        const parseData = this.JSONbigString.parse(data);
        const result = [];
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for (const key in parseData) {
          result.push({
            label: key,
            value: parseData[key],
          });
        }
        return result;
      } catch (e) {
        return data;
      }
    },
    handleFormat(title, data) {
      if (!data) {
        return;
      }
      this.title = title;
      try {
        this.formatData = this.JSONbigString.parse(data);
        this.canFormat = true;
      } catch (e) {
        this.formatData = data;
        this.canFormat = false;
      }
      this.dialogVisible = !this.dialogVisible;
    },
    async queryTraceInfo() {
      try {
        this.loading = true;
        let analyzeTimeFrom = '';
        let analyzeTimeTo = '';
        if (this.form.date?.length === 2) {
          analyzeTimeFrom = moment(this.form.date[0]).format('YYYY-MM-DD HH:mm:ss');
          analyzeTimeTo = moment(this.form.date[1]).format('YYYY-MM-DD HH:mm:ss');
        }

        const { data } = await queryTraceInfo({
          ...this.form,
          analyzeTimeFrom,
          analyzeTimeTo,
        });

        formatTraceInfos(data.traceInfos);
        this.tableData = data.traceInfos;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
  },
  beforeDestroy() {
    uid = 1;
  },
  mounted() {
    console.log(this.traceId, this.date);
    const { traceId = '' } = this.$route.query;
    this.form.traceId = traceId || this.traceId || '';
    if (this.date) {
      this.form = {
        ...this.form,
        date: [
          moment(`${this.date} 00:00:00`)._d,
          moment(`${this.date} 23:59:59`)._d,
        ],
      };
    } else {
      const date = moment().format('YYYY-MM-DD');
      this.form = {
        ...this.form,
        date: [
          moment(`${date} 00:00:00`)._d,
          moment(`${date} 23:59:59`)._d,
        ],
      };
    }

    this.queryTraceInfo();
  },
};
</script>
<style>
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text  {
  display: none;
}
</style>
<style scoped lang="scss">
.tracking-link {
  text-align: left;
  &-item {
    margin-bottom: 10px;
  }
  &-row {
    height: 95px;
    display: block;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.tracking-link-table {
  &::v-deep {
    .cell.el-tooltip {
      white-space: break-spaces;
    }
  }
}
</style>
